import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { IAuth, ILogin, IResponse } from 'src/utils/Interfaces/state.interface'
const BASE_URL = import.meta.env.VITE_BASE_URL

const REGISTER_URL = 'api/auth/signup'
const LOGIN_URL = 'api/auth/signin'
const LOGOUT_URL = 'api/auth/logout'
const CHECK_ADMIN_URL = 'api/auth/check-admin'

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: 'include'
  }),
  endpoints: (build) => ({
    getLogin: build.mutation<IResponse<IAuth>, ILogin>({
      query: (body) => ({
        url: LOGIN_URL,
        method: 'POST',
        body
      })
    }),
    register: build.mutation<IResponse<IAuth>, ILogin>({
      query: (body) => ({
        url: REGISTER_URL,
        method: 'POST',
        body
      })
    }),
    logOut: build.mutation<void, void>({
      query: () => ({
        url: LOGOUT_URL,
        method: 'POST'
      })
    }),
    checkAdmin: build.query<boolean, void>({
      query: () => ({
        url: CHECK_ADMIN_URL
      })
    }),
    googleAuth: build.mutation<IResponse<IAuth>, string>({
      query: (credential) => ({
        url: 'api/auth/google',
        method: 'POST',
        body: { credential }
      })
    })
  })
})

export const { useGetLoginMutation, useCheckAdminQuery, useRegisterMutation, useLogOutMutation, useGoogleAuthMutation } = authApi
